import { CheckedStatusEnum } from "./types";
export const TOOLTIP_LENGTH_DEFAULT = 22;
export const DATE_RANGE_BEFORE_YEARS = 15;
export const DATE_RANGE_AFTER_YEARS = 1;
export const emptyChecklistItem = {
    checked: false,
};
export const emptyChecklistItemWithStatus = {
    ...emptyChecklistItem,
    checkedStatus: CheckedStatusEnum.OPEN,
};
